export default __webpack_public_path__ + "static/media/download-icon.3974189e.svg";